import RestX from '~/RestX';

class LogService {
    // Associates a log-user with an logged-in user
    static identifyUser() {
        if (!window.heap) {
            return;
        }

        RestX.getInterfaces()
            .user.me.get()
            .then(data => {
                const userData = data.data || {};
                const userId = userData.id;
                window.heap.identify(userId);
            })
            .catch(err => console.log(err));
    }

    // Resets the identified user to anonymous-user
    static resetIdentity() {
        if (!window.heap) {
            return;
        }

        window.heap.resetIdentity();
    }
}

export default LogService;
